module.exports = __webpack_public_path__ + "static/media/success.115d4f98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/coupon/images/success.svg
// module id = 1564
// module chunks = 0